import { useCallback, useEffect, useRef, useState } from 'react';
import { ONE_MINUTE_IN_MS } from '../constants';

export function useDynamoPaginator() {
  const [pages, setPages] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);

  const handlePaginationResponse = useCallback(function(paginationResponse, targetPage) {
    const newPage = {};
    const pagesCopy = [...pages];
    if (paginationResponse.more) {
      newPage.nextPagePointer = paginationResponse.LastEvaluatedKey;
      newPage.lastPagePointer = targetPage < 2 ? null : pages[targetPage - 2].nextPagePointer;
      pagesCopy[targetPage] = newPage;
      setPages(pagesCopy);
    } else if (targetPage !== 0) {
      newPage.lastPagePointer = targetPage < 2 ? null : pages[targetPage - 2].nextPagePointer;
      pagesCopy[targetPage] = newPage;
      setPages(pagesCopy);
    } else {
      setPages([]);
    }
    setCurrentPage(targetPage);
  }, [pages, setPages, setCurrentPage]);

  const getLastEvaluatedKeyByPage = useCallback(
    function(nextPage) {
      if (nextPage > 0) {
        if (nextPage === currentPage) {
          return pages[currentPage - 1].nextPagePointer;
        }
        if (nextPage > currentPage) {
          return pages[currentPage].nextPagePointer;
        }
        return pages[currentPage].lastPagePointer;
      }
      return null;
    }, [pages, currentPage]);

  return [
    { pages, currentPage },
    handlePaginationResponse,
    getLastEvaluatedKeyByPage
  ];
}

export function useIntervalScheduler({ callback, enabled, intervalMs = ONE_MINUTE_IN_MS }) {
  const callbackRef = useRef(callback);

  useEffect(() => {
    console.debug(`Setting callbackRef to ${callback}`);
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    let intervalId = null;
    if (enabled) {
      intervalId = setInterval(() => callbackRef.current(), intervalMs);
      console.debug(`Setting intervalId to ${intervalId}`);
    }
    return () => {
      if (intervalId !== null) {
        console.debug(`Clearing intervalId ${intervalId}`);
        clearInterval(intervalId);
      }
    };
  }, [enabled, intervalMs]);
}